import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import type { VarianceIncident } from '../../features/variance-tracker/components/variance-supporting-data/models/variance-incident.model';

export interface VarianceIncidentDetailsClient {
  getIncidentDetails(incidentNumber: string, organizationId: string): Observable<VarianceIncident>;
}

export const VARIANCE_INCIDENT_DETAILS_CLIENT = new InjectionToken<VarianceIncidentDetailsClient>(
  'VARIANCE_INCIDENT_DETAILS_CLIENT',
);
